import { render, staticRenderFns } from "./coallook.vue?vue&type=template&id=48521dd6&scoped=true"
import script from "./coallook.vue?vue&type=script&lang=js"
export * from "./coallook.vue?vue&type=script&lang=js"
import style0 from "./coallook.vue?vue&type=style&index=0&id=48521dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48521dd6",
  null
  
)

export default component.exports